import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKlmComponent } from './simple-icons-klm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKlmComponent ],
    exports:      [ SimpleIconsKlmComponent ],
    bootstrap:    []
})
export class SimpleIconsKlmModule {}
